import type { Quiz } from "@core/features/quiz";

/** What the page says when a quiz has no wording of its own. */
export const FIT_QUIZ_DEFAULT_COPY = {
  title: "Is Pollinator right for you?",
  description: "Please confirm a few details to make sure Pollinator is a good fit for you.",
};

export type FitQuizCopy = {
  title: string;
  description: string;
  /** The last step's button, where the quiz names one */
  submitLabel?: string;
};

/**
 * The copy around an invitation's quiz: the quiz's own title, description
 * and submit label, as staff wrote them in admin, each falling back to the
 * page's wording where the quiz leaves it empty. Before the quiz has loaded
 * the page's wording stands in.
 */
export function fitQuizCopy(quiz: Quiz | undefined): FitQuizCopy {
  return {
    title: quiz?.title?.trim() || FIT_QUIZ_DEFAULT_COPY.title,
    description: quiz?.description?.trim() || FIT_QUIZ_DEFAULT_COPY.description,
    submitLabel: quiz?.config_object?.submit_label?.trim() || undefined,
  };
}
